import { render, staticRenderFns } from "./pdpJeanCoutuRaddar.vue?vue&type=template&id=bb9ef034&scoped=true"
import script from "./pdpJeanCoutuRaddar.vue?vue&type=script&lang=js"
export * from "./pdpJeanCoutuRaddar.vue?vue&type=script&lang=js"
import style0 from "./pdpJeanCoutuRaddar.vue?vue&type=style&index=0&id=bb9ef034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9ef034",
  null
  
)

export default component.exports